<div class="tags" *ngIf="pills.length" aria-label="Your roles">
  <span *ngFor="let pill of pills" class="tag is-rounded" [ngClass]="pill.tagClass">
    {{ pill.label }}
  </span>
</div>
